import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../../context/UserSummary";
import { FaMapMarkerAlt, FaMapPin, FaCheck } from "react-icons/fa";
import { GoHome } from "react-icons/go";
import { BiBed, BiBath } from "react-icons/bi";
import { BsDot, BsFillShareFill } from "react-icons/bs";
import Footer from "../../molecules/Footer/Footer";
import Foot from "../../molecules/Foot/Foot";
import "./ListSingle.css";
import { useParams } from "react-router-dom";
import DotLoader from "react-spinners/DotLoader";
import axios from "../../../api/axios";
import dashprofile from "../../../images/avatar/3.jpg";

const ListSingle = () => {
  const { isLoggedIn } = useContext(AuthContext);
  let { slug } = useParams();
  let url = `/api/show/visitor/property/${slug}`;

  const [listDetail, setListDetail] = useState(null);

  useEffect(() => {
    axios
      .get(url)
      .then((res) => {
        setListDetail(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => console.log(err));
  }, [url]);

  const decor = {
    textDecoration: "none",
  };

  if (!listDetail) {
    return (
      <div className="loading list-load">
        <DotLoader color={"#098FD2"} size={60} />
      </div>
    );
  }

  const {
    property_name,
    garage_size,
    no_bathrooms,
    no_bedrooms,
    property_image,
    property_price,
    street,
    state,
    ammentities,
    property_category,
    data_added,
  } = listDetail;

  console.log(listDetail);

  return (
    <div className="listing-wrapper">
      <div className="listing-container">
        <div className="list-single">
          <div className="trry">
            <div className="wrap-mini push">
              <div className="list-starter">
                <div className="home-list">
                  <div className="dot">
                    <Link style={decor} to="/">
                      <li className="home">Home</li>
                    </Link>{" "}
                    <BsDot className="dotted-icon" />
                  </div>
                </div>
                <div className="section-title">
                  <h2 className="propt">Property Detail</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="list-single-wrapper">
          <div className="list-single-wrap">
            <div className="section-headers">
              <div className="section-right-bar right-bar">
                <p>
                  For <span>{property_category}</span>
                </p>
              </div>
              <div className="share share-t">
                <BsFillShareFill className="share-icon" />
                <p className="share-tex">Share</p>
              </div>
            </div>
            <div className="list-grid">
              <div className="list-grid1">
                <div className="property-img">
                  <img src={property_image} alt="" />
                </div>
                <div className="list-head">
                  <div className="list-head-top">
                    <div className="top-left">
                      <div className="list-1">
                        <h2>{property_name}</h2>
                        <FaCheck className="check-green" />
                      </div>
                      {isLoggedIn ? (
                        <div className="list-2">
                          <FaMapMarkerAlt className="check-blue" />
                          <h3>{street}</h3>
                        </div>
                      ) : null}
                      <div className="list-2">
                        <FaMapPin className="check-blue" />
                        <h3>{state}</h3>
                      </div>
                    </div>
                    <div className="top-right">
                      <h5 className="span-list">
                        By <span>udeh princewill</span>
                      </h5>
                      <div className="list-imgg">
                        <img src={dashprofile} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="list-bottom">
                    <div className="list-btn">
                      {isLoggedIn ? (
                        <h5 className="list-price">
                          Price:
                          <span>₦{property_price}</span>
                        </h5>
                      ) : null}
                      <h5 className="list-price">
                        Date: <span>{data_added}</span>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="ammenityy">
                  <div className="inline-facts-wrap">
                    <GoHome className="list1-icon" />
                    <h3>Type</h3>
                    <h4>Apartment/House</h4>
                  </div>
                  <div className="inline-facts-wrap">
                    <FaMapPin className="list1-icon" />
                    <h3>Location</h3>
                    <h4>{state}</h4>
                  </div>
                  <div className="inline-facts-wrap">
                    <BiBed className="list1-icon" />
                    <h3>Bedroom</h3>
                    <h4>
                      {no_bedrooms} <span>Bedroom</span>
                    </h4>
                  </div>
                  <div className="inline-facts-wrap">
                    <BiBath className="list1-icon" />
                    <h3>Bathroom</h3>
                    <h4>
                      {no_bathrooms} <span>Full</span>
                    </h4>
                  </div>
                </div>
                <div className="description">
                  <h3>About this property</h3>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Saepe obcaecati a voluptas tempore facere dolor nemo ea amet
                    error dignissimos.
                  </p>
                  <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Voluptate inventore quibusdam adipisci atque pariatur amet
                    non maiores, porro, deserunt distinctio expedita accusamus!
                    Sint natus vitae aspernatur quidem eius nihil repellat quam
                    veritatis maiores molestiae nisi modi, ipsam ab laboriosam
                    cum sequi accusamus dignissimos provident praesentium nobis,
                    blanditiis dolores quibusdam commodi?
                  </p>
                  {isLoggedIn ? (
                    <button type="submit" className="purchase">
                      Purchase
                    </button>
                  ) : null}
                </div>
              </div>
              <div className="side-list">
                <div className="side-list-content">
                  <h3>Details</h3>
                  <div className="side-list-inner">
                    <h6>
                      Type: <span>Apartment/House</span>
                    </h6>
                  </div>
                  {isLoggedIn ? (
                    <div className="side-list-inner">
                      <h6>
                        Price:{" "}
                        <span>
                          ₦<span>{property_price}</span>
                        </span>
                      </h6>
                    </div>
                  ) : null}
                  <div className="side-list-inner">
                    <h6>
                      Bathroom: <span>{no_bathrooms}</span>
                    </h6>
                  </div>
                  <div className="side-list-inner">
                    <h6>
                      Bedroom: <span>{no_bedrooms}</span>
                    </h6>
                  </div>
                  <div className="side-list-inner">
                    <h6>
                      Garage size: <span>{garage_size}</span>
                    </h6>
                  </div>
                  <div className="side-list-inner">
                    <h6>
                      Date Listed: <span>{data_added}</span>
                    </h6>
                  </div>
                  <div className="side-list-inner">
                    <h6>
                      Ammenities: <span>{ammentities}</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-footer">
        <div className="inner-footer">
          <Footer />
        </div>
      </div>
      <div className="mini-footer">
        <div className="mini-footerr">
          <Foot />
        </div>
      </div>
    </div>
  );
};

export default ListSingle;
